module.exports = __webpack_public_path__ + "static/persona3-thumb-449627e468ac62fffbd84f353f9fa490.png";